import * as React from 'react';
import * as styles from './styles.css';

import { UIText2 } from '@cian/ui-kit';

import { IconFunctionalInformationCircle24 } from '@cian/ui-kit-design-tokens/icons';

interface IMyHomeMigrationBannerProps {
  onClick(): void;
}

export const MyHomeMigrationBanner: React.FC<IMyHomeMigrationBannerProps> = ({ onClick }) => {
  return (
    <div data-testid="MyHomeMigrationBanner" className={styles['container']}>
      <div className={styles['icon']}>
        <IconFunctionalInformationCircle24 color="icon-main-default" />
      </div>
      <div>
        <UIText2>
          Оценка переехала в новый раздел — Мой дом, он находится в Кабинете. Уже оценённые объекты тоже перенесли.
        </UIText2>
        <div data-testid="MyHomeMigrationBannerBtn" onClick={onClick} className={styles['link']}>
          <UIText2 color="text-main-default">Посмотреть</UIText2>
        </div>
      </div>
    </div>
  );
};

MyHomeMigrationBanner.displayName = 'MyHomeMigrationBanner';
